"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SheetBody = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const overlay_styles_1 = require("@/components/overlay/overlay.styles");
require("@/components/common");
let SheetBody = class SheetBody extends lit_1.LitElement {
    render() {
        return (0, lit_1.html) `
      <mm-scroll direction="column">
        <slot></slot>
      </mm-scroll>
    `;
    }
};
SheetBody.styles = overlay_styles_1.sheetBodyStyles;
SheetBody = __decorate([
    (0, decorators_js_1.customElement)('mm-sheet-body')
], SheetBody);
exports.SheetBody = SheetBody;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2hlZXQtYm9keS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInNoZWV0LWJvZHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsNkJBQXNDO0FBQ3RDLHFEQUFpRDtBQUVqRCx3RUFBcUU7QUFDckUsK0JBQTRCO0FBR3JCLElBQU0sU0FBUyxHQUFmLE1BQU0sU0FBVSxTQUFRLGdCQUFVO0lBR3ZDLE1BQU07UUFDSixPQUFPLElBQUEsVUFBSSxFQUFBOzs7O0tBSVYsQ0FBQTtJQUNILENBQUM7O0FBUk0sZ0JBQU0sR0FBRyxnQ0FBZSxDQUFBO0FBRHBCLFNBQVM7SUFEckIsSUFBQSw2QkFBYSxFQUFDLGVBQWUsQ0FBQztHQUNsQixTQUFTLENBVXJCO0FBVlksOEJBQVMifQ==